// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".bg-content[data-v-40d8d05b]{background:var(--v-secondary-lighten2)}@media screen and (min-width:600px){.bg-content[data-v-40d8d05b]{background:transparent}}", ""]);
// Exports
module.exports = exports;
